import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'
import { useDemandeCAPPStore } from '../../capp/useDemandeCAPPStore'
import { useDemandeCPROStore } from '../../cpro/useDemandeCPROStore'
import { useDemandePROAStore } from '../../proa/useDemandePROAStore'

import { useAppStateStore } from '@/features/application'
import router from '@/router'
import type { Dispositif } from '@/features/domaine/types/opco'
import { FetchResponseError } from '@/features/fetch'
import { useDemandeAFStore } from '../../af/useDemandeAFStore'


type IDemandeStore =
  ReturnType<typeof useDemandeCAPPStore> |
  ReturnType<typeof useDemandeAFStore> |
  ReturnType<typeof useDemandeCPROStore> |
  ReturnType<typeof useDemandePROAStore>

type LoadStoreResult = 'Ok' | 'Ko' | 'Accces Denied'

export function useDemandeRoutingService() {
  // Todo : à compléter
  const stores: { [key in Dispositif]: IDemandeStore } = {
    CAPP: useDemandeCAPPStore(),
    AF: useDemandeAFStore(),
    CPRO: useDemandeCPROStore(),
    PROA: useDemandePROAStore(),
  }

  const getStore = (disposif: Dispositif) => stores[disposif]

  async function loadStoreWithId(disposif: Dispositif, id: number): Promise<LoadStoreResult> {
    const store = getStore(disposif)

    try {
      await store.loadData(id)
      return 'Ok'
    } catch (error) {
      if (error instanceof FetchResponseError && error.status === 403) {
        return 'Accces Denied'
      }
      return 'Ko'
    }
  }

  function navigateToWithId(disposif: Dispositif, id: number) {
    const appState = useAppStateStore()
    const context = TypesContextesAutorisesEnum[appState.contextCourant]
    const pathDispositif = disposif.toLowerCase()
    // console.log(`/${context}/demande/${pathDispositif}/${id}`.toLowerCase())
    router.push(`/${context}/demande/${pathDispositif}/${id}`.toLowerCase())
  }

  return { loadStoreWithId, navigateToWithId, getStore }
}
